import Invoices from './Invoices';
import { usePageLoadTracking } from '../../../hooks/usePerformanceTracking';

/**
 * InvoicesPage - Page wrapper for the Invoices list view
 * 
 * The InvoicesDataProvider is provided at the route level in App.tsx
 * 
 * This component serves as the main entry point for the invoices system.
 * It wraps the Invoices component to provide consistent page structure.
 */
export default function InvoicesPage() {
  usePageLoadTracking('invoices-page');
  
  return <Invoices />;
}
